var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSelectedNumbers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8816 16.4652C19.3302 16.5788 20.9915 17.2024 21.766 17.5",
    stroke: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3644 16.3692C13.3846 16.3681 10.5744 17.5196 8.95466 18.8114C7.33487 20.1032 6.10612 21.931 5.43633 24.045C5.19839 24.798 5.36671 25.493 5.79324 26.032C6.23211 26.586 6.94594 26.965 7.74172 26.965H21.2303",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.183 22.233C30.1817 23.7499 29.5779 25.2041 28.5045 26.2758C27.431 27.3476 25.9758 27.9491 24.459 27.948C22.9421 27.9491 21.4869 27.3476 20.4135 26.2758C19.3401 25.2041 18.7363 23.7499 18.735 22.233C18.7363 20.7161 19.3401 19.2619 20.4135 18.1902C21.4869 17.1184 22.9421 16.5169 24.459 16.518C25.9758 16.5169 27.431 17.1184 28.5045 18.1902C29.5779 19.2619 30.1817 20.7161 30.183 22.233Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7635 11.6492C21.7624 12.9371 21.2524 14.2908 20.341 15.2009C19.4296 16.111 18.194 16.6218 16.906 16.621C15.6181 16.6221 14.3824 16.1115 13.4708 15.2016C12.5592 14.2917 12.0464 13.057 12.045 11.769C12.0461 10.481 12.5587 9.24621 13.4701 8.33612C14.3815 7.42604 15.6171 6.91522 16.905 6.91602C18.1929 6.91522 19.4283 7.4259 20.3396 8.33577C21.251 9.24564 21.7637 10.4802 21.765 11.768L21.7635 11.6492Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87 22.087L24.163 23.958L27.049 20.51",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSelectedNumbers);
export default __webpack_public_path__ + "static/media/serviceSelectedNumbers.8dc05ef479ed749a215d5e3628c41d89.svg";
export { ForwardRef as ReactComponent };